var _defs, _path, _path2, _path3, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    transform: "scale(8.844)",
    fill: "#fff",
    d: "M.162 0h-.324L0-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-144)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(144)",
    width: 18,
    height: 12
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v170.667H0z",
    fill: "#fecb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 341.333h512V512H0z",
    fill: "#ea2839"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170.667h512v170.666H0z",
    fill: "#34b233"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 9,
    y: 6.422,
    width: 18,
    height: 12,
    transform: "translate(-127.659) scale(42.66667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.2ddb3c8b6c4a6917e9f62c24fca9eabd.svg";
export { ForwardRef as ReactComponent };